module.exports = __webpack_public_path__ + "media/assets/images/flags/tl-0829dc425b31bb454cab8a41eca9de27.svg";